var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { Input, ListItem } from 'rcm-mobile';
import cls from 'classnames';
import './style/index.scss';
/**
 * @author sayll
 * @version 0.0.1
 *
 * 继承于 [Input](#/Components/Input) 组件
 */
export default class InputItem extends Input {
    constructor() {
        super(...arguments);
        this.state = {
            isWarn: false
        };
        this.refInput = React.createRef();
        this.handleOnBlur = (e) => {
            const { onBlur } = this.props;
            onBlur && onBlur(e);
            this.reportValidity();
        };
    }
    render() {
        const _a = this.props, { prefixCls, className, title, listOptions, hidden } = _a, resetProps = __rest(_a, ["prefixCls", "className", "title", "listOptions", "hidden"]);
        return (<div hidden={hidden} className={cls(prefixCls, className, { [`${prefixCls}-warn`]: this.state.isWarn })}>
        <ListItem title={title} arrow={null}>
          <Input hidden={hidden} {...resetProps} onBlur={this.handleOnBlur} ref={this.refInput}/>
        </ListItem>
      </div>);
    }
    get elem() {
        return this.refInput.current.elem;
    }
    /**
     * 重置当前输入域
     * @public
     * */
    reset() {
        this.value = '';
        this.refInput.current.setState({ value: '' });
    }
}
InputItem.defaultProps = Object.assign({}, Input.defaultProps, { prefixCls: 'x-input-item' });
